import { render } from "./rewardModal.vue?vue&type=template&id=570c7103&scoped=true"
import script from "./rewardModal.vue?vue&type=script&lang=js"
export * from "./rewardModal.vue?vue&type=script&lang=js"

import "./rewardModal.vue?vue&type=style&index=0&id=570c7103&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570c7103"]])

export default __exports__